import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Square = forwardRef<SVGSVGElement | null, IconFilledProps>(function Square({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M18.25 6C18.25 5.86193 18.1381 5.75 18 5.75H6C5.86193 5.75 5.75 5.86193 5.75 6V18C5.75 18.1381 5.86193 18.25 6 18.25H18C18.1381 18.25 18.25 18.1381 18.25 18V6ZM19.75 18C19.75 18.9665 18.9665 19.75 18 19.75H6C5.0335 19.75 4.25 18.9665 4.25 18V6C4.25 5.0335 5.0335 4.25 6 4.25H18C18.9665 4.25 19.75 5.0335 19.75 6V18Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          d='M19.75 18C19.75 18.9665 18.9665 19.75 18 19.75H6C5.0335 19.75 4.25 18.9665 4.25 18V6C4.25 5.0335 5.0335 4.25 6 4.25H18C18.9665 4.25 19.75 5.0335 19.75 6V18Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'square-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Square;
